import { showAlert } from "@components/alert/action";
import Button from "antd/lib/button";
import React, { Component } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const RealityCheckWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 156px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 15px 10px;
	gap: 10px;
	margin-bottom: 10px;

	.two-factor-auth {
		margin-top: 0;
	}

	.two-factor-auth-header {
		color: var(--profile-card-text-color);
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
	}

	.two-factor-auth-container {
		color: var(--content-text-color);
		text-align: center;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
	}

	.ant-btn[disabled],
	.ant-btn[disabled]:hover,
	.ant-btn[disabled]:focus,
	.ant-btn[disabled]:active {
		background: var(--main-gradient);
		color: #ffffff;
	}

	h3 {
		color: #f0052f;
		text-align: center;
		font-size: 12px;
		font-weight: 600;
		line-height: 20px;
		letter-spacing: 0.3px;
		margin: 0 0 10px 0;
	}

	.enabled-title {
		color: #18bb0c;
	}

	.notEnabled {
		color: #f0052f;
	}

	p {
		margin: 0 0 10px 0;
	}

	.reality-check-enable-btn {
		align-items: center;
		display: flex;
		width: 100%;
		justify-content: center;
		border-radius: 25px;

		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}

		background: var(--profile-card-button-bg);
		color: var(--button-color);
		opacity: 0.6;

		svg {
			path {
				fill: var(--button-color);
			}
		}
	}
`;

export class RealityCheck extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: localStorage.getItem("realityCheck.active") === "true",
		};
	}

	render() {
		const handleOnClick = (t) => {
			localStorage.setItem("realityCheck.active", this.state.active ? "false" : "true");
			this.setState({ active: !this.state.active }, () => {
				const msg = !this.state.active
					? t("realityCheck.disabled")
					: t("realityCheck.enable");
				this.props.showAlert({
					type: !this.state.active ? "error" : "success",
					msg,
					noTranslate: true,
				});
			});
		};
		return (
			<Translate>
				{({ translate }) => (
					<RealityCheckWrapper
						className="two-factor-auth"
						style={{
							marginTop: "0px",
						}}>
						<div className="two-factor-auth-header">{translate("Reality Check")}</div>
						<div className="two-factor-auth-container">
							{!this.state.active ? (
								<h3 className={!this.state.active && "notEnabled"}>
									{translate("realityCheck.disable")}
								</h3>
							) : (
								<h3 className="enabled-title">
									{translate("realityCheck.enable")}
								</h3>
							)}
							<p>{translate("realityCheck.profileDescription")}</p>
						</div>
						<Button
							type="default"
							className="reality-check-enable-btn"
							onClick={() => handleOnClick(translate)}>
							{translate(
								this.state.active
									? "realityCheck.disableBtn"
									: "realityCheck.enableBtn"
							)}
						</Button>
					</RealityCheckWrapper>
				)}
			</Translate>
		);
	}
}
const mapStateToProps = () => ({});

const mapDispatchToProps = {
	showAlert,
};
export default connect(mapStateToProps, mapDispatchToProps)(RealityCheck);
